import React, { Fragment } from 'react';
import About from './layout/About';
import Gallery from './layout/Gallery';
import HEM from './layout/HEM';
import Inspo from './layout/Inspo';
import Personalized from './layout/Personalized';
import Process from './layout/Process';
import Review from './layout/Reviews';
import Start from './layout/Start';
import SalonLocations from './SalonLocations';

const Home = () => {
    return (
        <Fragment>
            <header className="header-area">
                <div className="container">
                    <div className="header-cnt">
                        <p>Creators of the Habit Extension Method <br/> & The Perfect Blend</p>
                        <div className="habit-btn-containers">
                            <div className="book-container">
                                <a href="https://book.habitsalon.com/stylist" target="_blank" rel="noopener noreferrer" className="book-appointment">Book Appointment</a>
                                <a href="https://pay.withcherry.com/habit-beauty-salon" target="_blank" rel="noopener noreferrer" className="financing-link financing-link-desktop">Financing options available</a>
                            </div>
                            <div className="book-container">
                                <a href="https://habitshop.com/?ref=HabitSalon.com" target="_blank" rel="noopener noreferrer" className="book-appointment">Get Your Favorite Hair Care Products</a>
                                <a href="https://pay.withcherry.com/habit-beauty-salon" target="_blank" rel="noopener noreferrer" className="financing-link financing-link-mobile">Financing options available</a>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <About/>
            <SalonLocations/>
            <Start/>
            <Review/>
            <HEM/>
            <Personalized/>
            <Process/>
            <Inspo/>
            <Gallery/>
        </Fragment>
    )
}

export default Home;